"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo } from "react";
import FormSection from "../ui/FormSection";
import { TraitWrapper } from "../../traits/TraitWrapper";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { type AirdropEntry, AIRDROP_TOTAL } from "../types/OperationalData";
import { validateStrictAddress } from "../utils/addressValidation";
interface AirdropConfigProps {
  readonly entries: AirdropEntry[];
  readonly onEntriesChange: (entries: AirdropEntry[]) => void;
}
const AirdropConfig: React.FC<AirdropConfigProps> = t0 => {
  const $ = _c(59);
  const {
    entries,
    onEntriesChange
  } = t0;
  const totalAllocated = entries.reduce(_temp, 0);
  const remaining = AIRDROP_TOTAL - totalAllocated;
  const firstEntry = entries[0];
  const getAddressError = _temp2;
  let t1;
  if ($[0] !== entries || $[1] !== onEntriesChange || $[2] !== remaining) {
    t1 = () => {
      const defaultCount = Math.max(0, remaining);
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      onEntriesChange([...entries, {
        id,
        address: "",
        count: defaultCount
      }]);
    };
    $[0] = entries;
    $[1] = onEntriesChange;
    $[2] = remaining;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleAddEntry = t1;
  let t2;
  if ($[4] !== entries || $[5] !== onEntriesChange) {
    t2 = index => {
      if (entries.length <= 1) {
        return;
      }
      const newEntries = [...entries];
      newEntries.splice(index, 1);
      onEntriesChange(newEntries);
    };
    $[4] = entries;
    $[5] = onEntriesChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleRemoveEntry = t2;
  let t3;
  if ($[7] !== entries || $[8] !== onEntriesChange) {
    t3 = (index_0, value) => {
      const newEntries_0 = [...entries];
      const currentEntry = newEntries_0[index_0];
      if (!currentEntry) {
        return;
      }
      newEntries_0[index_0] = {
        ...currentEntry,
        address: value
      };
      onEntriesChange(newEntries_0);
    };
    $[7] = entries;
    $[8] = onEntriesChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleAddressChange = t3;
  let t4;
  if ($[10] !== entries || $[11] !== onEntriesChange) {
    t4 = (index_1, value_0) => {
      const newEntries_1 = [...entries];
      const currentEntry_0 = newEntries_1[index_1];
      if (!currentEntry_0) {
        return;
      }
      const numVal = Number.parseInt(value_0, 10);
      newEntries_1[index_1] = {
        ...currentEntry_0,
        count: Number.isNaN(numVal) ? 0 : Math.max(0, numVal)
      };
      onEntriesChange(newEntries_1);
    };
    $[10] = entries;
    $[11] = onEntriesChange;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleCountChange = t4;
  const isOverAllocated = totalAllocated > AIRDROP_TOTAL;
  const isUnderAllocated = totalAllocated < AIRDROP_TOTAL;
  const isExactlyAllocated = totalAllocated === AIRDROP_TOTAL;
  let t5;
  if ($[13] !== isExactlyAllocated || $[14] !== isOverAllocated) {
    t5 = () => {
      if (isExactlyAllocated) {
        return "tw-bg-green/10 tw-border tw-border-green/30";
      }
      if (isOverAllocated) {
        return "tw-bg-red/10 tw-border tw-border-red/30";
      }
      return "tw-bg-iron-800/50 tw-border tw-border-iron-700";
    };
    $[13] = isExactlyAllocated;
    $[14] = isOverAllocated;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const getSummaryBarClasses = t5;
  let t6;
  if ($[16] !== isExactlyAllocated || $[17] !== isOverAllocated) {
    t6 = () => {
      if (isOverAllocated) {
        return "tw-text-red";
      }
      if (isExactlyAllocated) {
        return "tw-text-green";
      }
      return "tw-text-iron-100";
    };
    $[16] = isExactlyAllocated;
    $[17] = isOverAllocated;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const getTotalTextColorClass = t6;
  const t7 = `tw-mb-4 tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-px-4 tw-py-3 ${getSummaryBarClasses()}`;
  const t8 = `tw-font-bold ${getTotalTextColorClass()}`;
  let t9;
  if ($[19] !== t8 || $[20] !== totalAllocated) {
    t9 = <span className="tw-text-sm tw-text-iron-300">Total allocated:{" "}<span className={t8}>{totalAllocated}</span>{" "}/ {AIRDROP_TOTAL}</span>;
    $[19] = t8;
    $[20] = totalAllocated;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isOverAllocated || $[23] !== remaining) {
    t10 = isOverAllocated && <span className="tw-text-sm tw-font-medium tw-text-red">{Math.abs(remaining)} over limit</span>;
    $[22] = isOverAllocated;
    $[23] = remaining;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== isUnderAllocated || $[26] !== remaining) {
    t11 = isUnderAllocated && <span className="tw-text-sm tw-text-iron-400">{remaining} remaining</span>;
    $[25] = isUnderAllocated;
    $[26] = remaining;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== isExactlyAllocated) {
    t12 = isExactlyAllocated && <span className="tw-text-sm tw-font-medium tw-text-green">Complete</span>;
    $[28] = isExactlyAllocated;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t7 || $[34] !== t9) {
    t13 = <div className={t7}>{t9}{t10}{t11}{t12}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t7;
    $[34] = t9;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== entries || $[37] !== handleAddressChange || $[38] !== handleCountChange || $[39] !== handleRemoveEntry) {
    let t15;
    if ($[41] !== entries.length || $[42] !== handleAddressChange || $[43] !== handleCountChange || $[44] !== handleRemoveEntry) {
      t15 = (entry, index_2) => <div key={entry.id} className="tw-flex tw-items-start tw-gap-x-3"><TraitWrapper label="Wallet Address" id={`airdrop-${index_2}-address`} error={getAddressError(entry.address)} isFieldFilled={!!entry.address && !getAddressError(entry.address)} className="tw-flex-1"><input type="text" placeholder="0x..." value={entry.address} onChange={e_0 => handleAddressChange(index_2, e_0.target.value)} className={`tw-form-input tw-w-full tw-truncate tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-py-3 tw-pl-4 tw-pr-11 tw-text-sm tw-text-iron-100 tw-outline-none tw-ring-1 ${getAddressError(entry.address) ? "tw-ring-red" : "tw-ring-iron-700"} focus:tw-ring-primary-400`} /></TraitWrapper><TraitWrapper label="Count" id={`airdrop-${index_2}-count`} isFieldFilled={!!entry.count} className="tw-w-24"><input type="number" min="0" max={AIRDROP_TOTAL} value={entry.count || ""} onChange={e_1 => handleCountChange(index_2, e_1.target.value)} className="tw-form-input tw-w-full tw-truncate tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-py-3 tw-pl-4 tw-pr-11 tw-text-sm tw-text-iron-100 tw-outline-none tw-ring-1 tw-ring-iron-700 focus:tw-ring-primary-400" /></TraitWrapper>{entries.length > 1 && <button type="button" onClick={() => handleRemoveEntry(index_2)} className="tw-mt-2 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-2 tw-text-iron-400 tw-transition-colors tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-rose-400" aria-label={`Remove address ${index_2 + 1}`}><TrashIcon className="tw-size-5 tw-flex-shrink-0" /></button>}</div>;
      $[41] = entries.length;
      $[42] = handleAddressChange;
      $[43] = handleCountChange;
      $[44] = handleRemoveEntry;
      $[45] = t15;
    } else {
      t15 = $[45];
    }
    t14 = entries.map(t15);
    $[36] = entries;
    $[37] = handleAddressChange;
    $[38] = handleCountChange;
    $[39] = handleRemoveEntry;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[46] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-y-4">{t14}</div>;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PlusIcon className="tw-size-4 tw-flex-shrink-0" />;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== handleAddEntry) {
    t17 = <button type="button" onClick={handleAddEntry} className="tw-mt-4 tw-flex tw-cursor-pointer tw-items-center tw-gap-x-1.5 tw-border-0 tw-bg-transparent tw-text-sm tw-font-semibold tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300">{t16}Add Address</button>;
    $[49] = handleAddEntry;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== entries.length || $[52] !== firstEntry?.address) {
    t18 = entries.length === 1 && !firstEntry?.address && <p className="tw-mt-3 tw-text-xs tw-text-iron-500">Enter at least one wallet address to receive airdrops.</p>;
    $[51] = entries.length;
    $[52] = firstEntry?.address;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] !== t13 || $[55] !== t15 || $[56] !== t17 || $[57] !== t18) {
    t19 = <FormSection title="Airdrop Distribution">{t13}{t15}{t17}{t18}</FormSection>;
    $[54] = t13;
    $[55] = t15;
    $[56] = t17;
    $[57] = t18;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  return t19;
};
export default React.memo(AirdropConfig);
function _temp(sum, e) {
  return sum + (e.count || 0);
}
function _temp2(address) {
  if (!address) {
    return null;
  }
  return validateStrictAddress(address) ? null : "Invalid address (0x... 42 chars)";
}